import React from "react";
import Tv from "../component/Tv";
import NavigationBar from "../component/Layout/NavigationBar";

function TvPage() {
  return (
    <>
      <NavigationBar />
      <Tv />
    </>
  );
}

export default TvPage;
